import React from 'react';

const FAQ: React.FC = () => (
  <div className="static-page">
    <h1>Frequently Asked Questions</h1>
    <p>Find answers to common questions about our services, immigration processes, and case preparation. For more specific inquiries, please contact us directly.</p>
  </div>
);

export default FAQ;
